import React, { Component } from 'react';
import * as Config from './../config/Config';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';

import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getNewPost} from '../actions/newPostAction';
const $=window.$;

//const $=window.$;
// const win=window;

class OpinionPoll extends Component {
	constructor(props) {
		super(props);

        this.state={
        	poll_qust_value:[],
        	view_results:[],
        	
        };
		this.getLrinfo=this.getLrinfo.bind(this);

	}	

	fnadd_poll(i,assigned_id) {

	 let learnerID   = Common.getUserData("id", true);
	 let pinID   = Common.getUserData("pinID", true);

	 let div_poll="div_poll"+i;
	  let rdopoll_ans = i+"rdopoll_ans[]";
	  let poll_div = "poll_div"+i;
	 let chkedpoll_ans =0;
	  let count=0;
		  $('.rdopoll'+i).each(function () {		  	
		  	$(this).val() + "-" + (this.checked ? chkedpoll_ans = $(this).val() : count);
		  });

		 if(chkedpoll_ans==0){
		   $('#poll_div'+i).css('display','block');
		   return false;
		 }else{
	  
	  let answer_poll= 'answer_poll';
	  
	  let hidPoll_id = $("#hidPoll_id"+i).val();
	  // alert(learnerID+'--'+answer_poll+'--'+chkedpoll_ans+'--'+hidPoll_id+'--'+assigned_id);
	  // return false;
	  if(chkedpoll_ans!="" && hidPoll_id!="" && assigned_id!="") {

		 Common.reactLoader("show", "Please wait...");
	    	fetch(Config.domainUrl+'group-interactions/answerpoll', {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json',
	                  'Content-Type': 'application/json',
										'Authorization':'Bearer ' +Common.getTokenData()
	                },
	                  body: JSON.stringify({
	                    learnerID:learnerID,
						q:answer_poll,
						trid:i,
						chkedpoll_ans:chkedpoll_ans,
						hidPoll_id:hidPoll_id,
						assigned_id:assigned_id,
						pinID:pinID
	                  })
	                }).then((response) => response.json())
	               .then((responseJson) => {
							this.getOpinionpolls();
							 setTimeout(() => {
								this.props.getNewPost();
					          }, 5000);        
							// let opinion_polls_count=(responseJson.opinion_polls_count!=undefined || responseJson.opinion_polls_count!=null)?responseJson.opinion_polls_count:0;
							// Common.setUserData('opinion_polls_count',opinion_polls_count,true);	
							// this.props.opinion(opinion_polls_count);
							Common.reactLoader("hide");
							Common.downTabClose();
	   		 			});
	           }    
	           //count end else
	       }
	    
	}

	getTabs(){
	           window.$('#parentHorizontalTab').easyResponsiveTabs({
	                type: 'default', //Types: default, vertical, accordion
	                width: 'auto', //auto or any width like 600px
	                fit: true, // 100% fit in a container
	                //closed: 'accordion', // Start closed if in accordion view
	                tabidentify: 'hor_1', // The tab groups identifier
	                activate: function (event) { // Callback function if tab is switched

	                    var $tab = $(this);
	                    var $info = $('#nested-tabInfo');
	                    var $name = $('span', $info);

	                    $name.text($tab.text());

	                    $info.show();
	                }
	            });

							window.$('#ChildVerticalTab_1').easyResponsiveTabs({
			            type: 'vertical',
			            width: 'auto',
			            fit: true,
			            tabidentify: 'ver_1', // The tab groups identifier
			            //resp-tab-active
			           /* activate: function (event) { // Callback function if tab is switched
			                alert('sdf');
			               $('[aria-controls="ver_1_tab_item-2"]').click();
			               alert('dd');
			            } */
			        });
    }
	
	getOpinionpolls(){
			let learnerID   = Common.getUserData("id", true);
			let pinNo 		= Common.getUserData("pinNo", true);
			let pinID 		= Common.getUserData("pinID", true);
			let corporateID = Common.getUserData("corporateID", true);
			let productID 	= Common.getUserData("productID", true);
			let specialExpiryDate = Common.getUserData("specialExpiryDate", true);

			Common.reactLoader("show", "Please wait...");
    	fetch(Config.domainUrl+'group-interactions/opinionpolls', {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/json',
									'Authorization':'Bearer ' +Common.getTokenData()
                },
                  body: JSON.stringify({
                    learnerID:learnerID,
					pinNo:pinNo,
					pinID:pinID,
					corporateID:corporateID,
					productID:productID
                  })
                }).then((response) => response.json())
               .then((responseJson) => {
                	if(responseJson.status != 0){	
						 let poll_qust_value=(responseJson.opinionpolls.poll_qust_value!=undefined) ? responseJson.opinionpolls.poll_qust_value : '';
						 let view_results=(responseJson.opinionpolls.view_results!=undefined) ? responseJson.opinionpolls.view_results : '';
						
						 this.setState({
							 opinionpolls: responseJson.opinionpolls,
							 poll_qust_value:poll_qust_value,
							 view_results:view_results
						 });
						Common.reactLoader("hide");
						Common.downTabClose();
					}
   		 		});
    }

	componentDidMount() {
		this.getTabs();
		this.getOpinionpolls();
	}

	getLrinfo(type,lr_id,dlr_id){
		this.props.switchPanel(type,lr_id,dlr_id);
	}

		render() {
			let poll_qust_value = null;
			if(this.state.poll_qust_value != null || this.state.poll_qust_value != undefined){
				  poll_qust_value=this.state.poll_qust_value.map((key,index)=>{
					return <div key={`polls_contents${index}`} className="polls-content"  id={`div_poll${index}`}>
		                      <h1>{key.poll_question}</h1>
		                        <div className="polls-form">
		                          <ul>
		                          {key['question'].map((values,i)=>{
		                              	return  <div key={`poll_ans_key${i}`}> <li><input type="radio" className={`rdopoll${index} rdbtn`} name="i_rdopoll_ans[]" id="i_rdopoll_ans[]"  value={values.poll_ans_id_pk} />
		                                      &nbsp;{values.poll_answer}</li></div>
		                              })
		                          }			         
		                          <div id={`poll_div${index}`} className="errornoTM" style={{display: 'none'}}><font color="#FF0000">Please select the opinion polls</font></div>                           
		                          </ul>
		                          <div id={`poll_div${index}`} className="errornoTM"></div>
		                          <div className="poll-submit poll-btn-right">
		                          <input type="button" value="Vote" title="Vote" alt="Vote" name="vote" onClick={(e) =>this.fnadd_poll(index,key.assigned_poll_id_pk)} />  							</div>
		                        </div>
		                        <input type="hidden" name={`hidPoll_id${index}`} id={`hidPoll_id${index}`} value={key.poll_id_pk} />			                            
		                    </div>
				});
			}
			let view_results = null;
			if(this.state.view_results != null || this.state.view_results != undefined){
				 view_results=this.state.view_results.map((key,index)=>{
						return <div key={`view_poll_contents${index}`} className="polls-content">
											<h1>{key.poll_question}
									        <div key={`view_poll_votes${index}`} className="votes"> Total Votes : <span>{key.total_vote}</span> </div>
									      </h1>
									      <div key={`view_poll_form_results${index}`} className="polls-form polls-results">
									       {key['view_res'].map((view_key,view_i)=>{
									       	let strsingle_vote_mul_width = view_key.strsingle_vote_mul;
									           return <div key={`key12${view_i}`}><ul key={`key1${view_i}`} className="arrow-list">
									                <li className="opp_arrow">{view_key.poll_answer}</li>
									                <li>                   
									                  <div className="meter orange">
									                    <span style={{width:strsingle_vote_mul_width+'%'}}></span>
									                  </div>    {view_key.strsingle_vote_mul}% 
									                </li>
									                <li className="txt-red1">(Votes : {view_key.single_vote})</li>
									              </ul></div>
									              })
									          }

									      </div>


									 </div>
					});
				}
	
		return (
		 <section id="contentsection" className="contentarea">
          <div className="inner-title-bg journey-tit-bg">
            <h1> <span> <img src={process.env.PUBLIC_URL+'/images/opinion_polls_img.png'} align="absmiddle" alt="" border="0" /> </span> Opinion Polls<br />
              <span className="subtitle">Let us know what you think and view the trends.</span></h1>
          </div>

          <div className="myperformance opinion-polls">
			  <section id="semana-scroll-inner" className="scroll">
			    <section className="viewport">
			      <section className="overview">
			          <div className="inner-content">
			            <div id="parentHorizontalTab">
			                <ul className="resp-tabs-list hor_1 horizontaltabbg">
			                  <li>Opinion Polls<div className="activearrow"><img src={process.env.PUBLIC_URL+'/images/activetab.png'} alt="" border="0" /></div></li>
			                  <li className="pgeLoad">View Results<div className="activearrow"><img src={process.env.PUBLIC_URL+'/images/activetab.png'} alt="" border="0" /></div></li>
			                </ul>
			              <div className="resp-tabs-container hor_1 ">

			                <div className="tab-content">           
			                  <form name="poll_form" id="poll_form" action="" method="post">

			                        {(poll_qust_value!='')? 
			                        	<div>
			                        	{poll_qust_value}
			                        	</div>
			                        	:
			                        	<div className="timebox light-graybox">
			                  				<p> Currently there is no active opinion poll. Please check back later.</p>
			                  			</div>
			                        }			                      
			                  </form>      
			                </div>

			                <div className="tab-content" >
			                  	{(view_results!='')?
					                  	<div>{view_results}</div>
					                  	:
									<div className="timebox light-graybox">
									      <p> You have not answered any of the opinion polls yet.</p>
									</div>
								}

			                </div> 

			              </div>
			            </div>
			          </div>        
			      </section>
			    </section>
			  </section>
			</div>
         
        </section>

			);

		}
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getNewPost}, dispatch);
 
}

export default connect(null,mapDispatchToProps)(OpinionPoll);




// WEBPACK FOOTER //
// ./src/group_interactions/OpinionPoll.js